import {
    PreviewBox,
    PreviewOverlayBox,
    PreviewOverlayIconButton,
} from "./PreviewCardSwiper.styles";
import { PostDetailsActionType } from "../Modals/PostDetailsModal/PostDetailsModalStore";
import { PostDetailsPageActions } from "../Modals/PostDetailsModal/PostDetailsModal";
import { MediaListType } from "@infrastructure/Services/MediaService";
import { Typography } from "@mui/material";
import { ImagesIcon } from "@icons/ImagesIcon";

export function PreviewSlider({
    media,
    onPostCardClick,
    showMoreImagesOverlay,
}: {
    media: MediaListType;
    onPostCardClick: (postId: string, action?: PostDetailsActionType) => void;
    showMoreImagesOverlay: boolean;
}) {
    let desiredAction: PostDetailsActionType;

    if (media.commentId) {
        desiredAction = {
            desiredAction: PostDetailsPageActions.PIN_COMMENT,
            commentId: media.commentId.toString(),
        };
    }
    return (
        <PreviewBox
            onClick={() => {
                onPostCardClick(media.postId.toString(), desiredAction);
            }}
        >
            {showMoreImagesOverlay && (
                <PreviewOverlayBox>
                    <PreviewOverlayIconButton>
                        <ImagesIcon
                            width={"24px"}
                            height={"24px"}
                            color={"#FFF"}
                        />
                    </PreviewOverlayIconButton>
                    <Typography
                        fontSize={"14px"}
                        fontWeight={700}
                        color={"var(--community-color-snow-white)"}
                    >
                        weitere Bilder
                    </Typography>
                </PreviewOverlayBox>
            )}
            <img src={media.imageUrl} />
        </PreviewBox>
    );
}
